import { render, staticRenderFns } from "./courseStudy.vue?vue&type=template&id=dec4a40a&scoped=true"
import script from "./courseStudy.vue?vue&type=script&lang=js"
export * from "./courseStudy.vue?vue&type=script&lang=js"
import style0 from "./courseStudy.vue?vue&type=style&index=0&id=dec4a40a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec4a40a",
  null
  
)

export default component.exports